function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.92 8.5v-.004A6.46 6.46 0 0012.524 3H3.5A1.502 1.502 0 002 4.5v18A1.502 1.502 0 003.5 24h14a1.502 1.502 0 001.5-1.5V9.479a6.538 6.538 0 00-.08-.978zM17.774 8H14.5a.5.5 0 01-.5-.5V4.226A5.305 5.305 0 0117.774 8zM18 22.5a.501.501 0 01-.5.5h-14a.5.5 0 01-.5-.5v-18a.5.5 0 01.5-.5h9.028c.16 0 .314.033.472.046V7.5A1.502 1.502 0 0014.5 9h3.454c.013.16.046.316.046.478z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5 21H20a.5.5 0 010-1h.5a.501.501 0 00.5-.5V6.478A5.475 5.475 0 0015.528 1H6.5a.5.5 0 00-.5.5V2a.5.5 0 01-1 0v-.5A1.502 1.502 0 016.5 0h9.025A6.474 6.474 0 0122 6.479V19.5a1.502 1.502 0 01-1.5 1.5z"
});

function SvgDuplicate(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "duplicate.1897f.svg";
export { SvgDuplicate as ReactComponent };